import styled from 'styled-components';

import { colors, fonts, device } from 'shared/defaultTheme';

export const CloseButton = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  @media ${device.sm} {
    width: 98%;
  }
  @media ${device.md} {
    width: 98%;
  }
  @media ${device.lg} {
    width: 98%;
  }
  @media ${device.xl} {
    width: 92%;
  }
  .close-button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.2rem;
    margin: 0 0 1rem 0;
    font-family: 'MTTMilano', sans-serif;
    font-size: 16px;
    line-height: 19px;
    border: unset;
    background-color: ${colors.transparent};
  }
  svg {
    height: 22px;
    width: 22px;
    margin-left: 8px;
  }
`;

export const ResultsWrapper = styled.div`
  display: flex;

  .e-grid .e-icon-filter::before {
    content: '\\e736';
    font-size: medium;
  }

  .header-template-icon {
    height: 18px;
    width: 18px;
  }

  .e-headercelldiv {
    text-transform: uppercase;
    color: ${colors.black};
    font-family: 'MTTMilano-Bold', sans-serif;
  }

  .backgroundbox-wrapper {
    margin-bottom: 25px;
    @media ${device.sm} {
      flex: 0 0 97%;
      width: 0 0 97.2%;
      margin-left: 6px;
      .result-spinner {
        top: -7%;
      }
      .nav {
        display: block;
        margin-top: 15px;
      }
      .nav-item {
        width: 100%;
      }
      .form__flex-auto {
        flex: auto;
        flex-direction: column;
      }
      .ml-filter-section {
        margin-left: -1rem;
        flex-direction: column !important;
        align-items: flex-start !important;
      }
    }
    @media ${device.md} {
      flex: 0 0 97.2%;
      width: 0 0 97.2%;
      margin-left: 11px;
      .result-spinner {
        top: -42%;
      }
      .nav {
        display: flex;
        margin-top: 0;
      }
      .nav-item {
        width: 154px;
      }
      .form__flex-auto {
        flex: auto;
        flex-direction: column;
      }
      .ml-filter-section {
        margin-left: -1rem;
      }
    }
    @media ${device.lg} {
      flex: 0 0 97%;
      margin-left: 8px;
      .result-spinner {
        top: -42%;
      }
      .nav {
        display: flex;
        margin-top: -12px;
      }
      .nav-item {
        width: 125px;
      }
      .form__flex-auto {
        flex: auto;
        flex-direction: row;
      }
      .ml-filter-section {
        margin-left: 3rem;
      }
    }
    @media ${device.xl} {
      flex: 0 0 92%;
      margin-left: 0;
      .result-spinner {
        top: 0;
      }
      .nav {
        display: flex;
        margin-top: -12px;
      }
      .nav-item {
        width: 125px;
      }
      .form__flex-auto {
        flex: auto;
        flex-direction: row;
      }
      .ml-filter-section {
        margin-left: 3rem;
      }
    }
    min-height: 534px;
    height: auto;
    overflow-y: auto;
    .hide-span-text {
      visibility: hidden;
    }
  }

  .filter-container {
    @media ${device.sm} {
      width: 100%;
    }
    @media ${device.md} {
      width: 40%;
    }
    @media ${device.lg} {
      width: 30%;
    }
    @media ${device.xl} {
      width: 30%;
    }
    .selector-filter-by-wrapper {
      span {
        color: ${colors.black};
        font-family: ${fonts.default};
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
        margin-right: 7px;
      }
      .selector {
        width: 633px;
      }
    }
  }

  .general-search-input {
    margin: auto;
    margin-bottom: 1.5rem;
    @media ${device.sm} {
      width: 100%;
    }
    @media ${device.md} {
      width: 60%;
    }
    @media ${device.lg} {
      width: 50%;
    }
    @media ${device.xl} {
      width: 50%;
    }
  }

  .classificationWrapper {
    display: flex;
    justify-content: center;
    button {
      padding: 0;
      background-color: #aaaeb0;
      border-radius: 10px;
      height: 20px;
      width: 35px;
      color: #fff;
      font-size: 13px;
    }
  }

  #Grid {
    border: none;
    tbody {
      tr {
        height: 54px;
      }
    }
    .e-gridheader {
      border-top: none;
    }
    .e-icon-first {
      &::before {
        content: '\\e94d';
        font-family: 'lf-font', sans-serif;
        font-weight: bold;
      }
    }
    .e-icon-last {
      &::before {
        content: '\\e94e';
        font-family: 'lf-font', sans-serif;
        font-weight: 700;
      }
    }
    .e-sortfilterdiv {
      position: relative;
      float: left;
      top: 20px;
    }
    .e-headercelldiv {
      float: left;
      padding: 0;
      margin: 0;
    }
    .e-icon-filter {
      float: left;
      top: 17px;
      left: 4px;
    }
    .e-pagerconstant {
      height: 25px;
      position: relative;
      bottom: 0;
      padding: 0 0 0 12px;
      margin: 0;
      .e-constant {
        display: flex;
        height: 20px;
        align-items: center;
      }
    }
    .e-rowcell {
      font-family: MTTMilano-Medium;
      font-size: 14px;
      padding-left: 0px;
    }
    .e-headertext {
      font-family: MTTMilano-Bold;
    }
    .e-headercell {
      padding: 0;
      margin: 0 10px !important;
    }
  }
`;

export const ClientResultsWrapper = styled.div`
  tbody {
    tr {
      cursor: pointer;
      &:hover {
        background-color: ${colors.lightGray};
      }
    }
  }
  .address-info {
    white-space: nowrap;
    width: 200px;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .status-wrapper {
    font-family: ${fonts.default};
    font-weight: 900;
    font-size: 13px;
    line-height: 15px;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 20px;
    width: 82px;
    text-transform: capitalize;
  }
  @media ${device.sm} {
    .client-results-table {
      overflow-x: auto;
      display: block;
      max-width: fit-content;
      white-space: nowrap;
    }
  }
  @media ${device.md} {
    .client-results-table {
      overflow-x: auto;
      display: block;
      max-width: fit-content;
      white-space: nowrap;
    }
  }
  @media ${device.lg} {
    .client-results-table {
      overflow-x: auto;
      display: inline-table;
      max-width: initial;
      white-space: nowrap;
    }
  }
  @media ${device.xl} {
    .client-results-table {
      overflow-x: auto;
      display: inline-table;
      max-width: initial;
      white-space: nowrap;
    }
  }
  padding-top: 33px;
  #Grid {
    border: none;
    tbody {
      tr {
        height: 54px;
      }
    }
    .e-gridheader {
      border-top: none;
    }
    .e-icon-first {
      &::before {
        content: '\\e94d';
        font-family: 'lf-font', sans-serif;
        font-weight: bold;
      }
    }
    .e-icon-last {
      &::before {
        content: '\\e94e';
        font-family: 'lf-font', sans-serif;
        font-weight: 700;
      }
    }
    .e-sortfilterdiv {
      position: relative;
      float: left;
      top: 20px;
    }
    .e-headercelldiv {
      float: left;
      padding: 0;
      margin: 0;
    }
    .e-icon-filter {
      float: left;
      top: 17px;
      left: 4px;
    }
    .e-pagerconstant {
      height: 25px;
      position: relative;
      bottom: 0;
      padding: 0 0 0 12px;
      margin: 0;
      .e-constant {
        display: flex;
        height: 20px;
        align-items: center;
      }
    }
    .e-rowcell {
      font-family: MTTMilano-Medium;
      font-size: 14px;
      padding-left: 0px;
    }
    .e-headertext {
      font-family: MTTMilano-Bold;
    }
  }
`;

export const DocumentationResultsWrapper = styled.div`
  padding-top: 33px;

  .icon-type {
    fill: ${colors.black};
    height: 18px;
    width: 22px;
  }
  tbody {
    tr {
      cursor: pointer;
      &:hover {
        background-color: ${colors.lightGray};
      }
    }
  }
  .public-wrapper {
    color: ${colors.white};
    font-family: ${fonts.default};
    font-weight: 900;
    font-size: 13px;
    line-height: 15px;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 20px;
    width: 82px;
    margin: auto;
    &.public-yes {
      background-color: ${colors.pastelGreen};
    }
    &.public-no {
      background-color: ${colors.strongRed};
    }
  }
  @media ${device.sm} {
    .documentation-results-table {
      overflow-x: auto;
      display: block;
      max-width: fit-content;
      white-space: nowrap;
    }
  }
  @media ${device.md} {
    .documentation-results-table {
      overflow-x: auto;
      display: inline-table;
      max-width: initial;
      white-space: nowrap;
    }
  }
  @media ${device.lg} {
    .documentation-results-table {
      overflow-x: auto;
      display: inline-table;
      max-width: initial;
      white-space: nowrap;
    }
  }
  @media ${device.xl} {
    .documentation-results-table {
      overflow-x: auto;
      display: inline-table;
      max-width: initial;
      white-space: nowrap;
    }
  }
  .status-wrapper {
    font-family: ${fonts.default};
    font-weight: 900;
    font-size: 13px;
    line-height: 15px;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 20px;
    width: 82px;
    text-transform: capitalize;
    margin: auto;
  }
  #Grid {
    border: none;
    tbody {
      tr {
        height: 54px;
      }
    }
    .e-gridheader {
      border-top: none;
    }
    .e-icon-first {
      &::before {
        content: '\\e94d';
        font-family: 'lf-font', sans-serif;
        font-weight: bold;
      }
    }
    .e-icon-last {
      &::before {
        content: '\\e94e';
        font-family: 'lf-font', sans-serif;
        font-weight: 700;
      }
    }
    .e-sortfilterdiv {
      position: relative;
      float: left;
      top: 20px;
    }
    .e-headercelldiv {
      float: left;
      padding: 0;
      margin: 0;
    }
    .e-icon-filter {
      float: left;
      top: 17px;
      left: 4px;
    }
    .e-pagerconstant {
      height: 25px;
      position: relative;
      bottom: 0;
      padding: 0 0 0 12px;
      margin: 0;
      .e-constant {
        display: flex;
        height: 20px;
        align-items: center;
      }
    }
    .e-rowcell {
      font-family: MTTMilano-Medium;
      font-size: 14px;
      padding-left: 0px;
    }
    .e-headertext {
      font-family: MTTMilano-Bold;
    }
  }
`;

export const LinkDiv = styled.div`
  color: ${({ mainColor }) => mainColor};
  cursor: pointer;
`;
